import { useEffect } from 'react';

interface Props {
  enabled: boolean;
  scrollHeight?: number;
  navigationKey?: string;
}

const useClipContentHeight = ({ enabled, scrollHeight = 100, navigationKey }: Props) => {
  useEffect(() => {
    if (!enabled) {
      return;
    }

    const bodyEl = document.body;
    const htmlEl = document.documentElement;

    const applyClip = () => {
      const contentBounds = document.querySelector('.rendered-post')?.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      let newHeight = `calc(100vh + ${scrollHeight}px)`;

      if (contentBounds && contentBounds.bottom + window.scrollY < windowHeight) {
        newHeight = '100vh';
      }

      window.scrollTo(0, 0);
      bodyEl.style.height = newHeight;
      bodyEl.style.overflow = 'hidden';
      bodyEl.style.userSelect = 'none';
      htmlEl.style.overflow = 'auto';
    };

    // rAF ensures styles apply after Remix scroll restoration on navigation
    const rafId = requestAnimationFrame(() => {
      applyClip();
    });

    return () => {
      cancelAnimationFrame(rafId);
      bodyEl.style.height = '';
      bodyEl.style.overflow = '';
      bodyEl.style.userSelect = '';
      htmlEl.style.overflow = '';
    };
  }, [enabled, scrollHeight, navigationKey]);
};

export default useClipContentHeight;
